import { render, staticRenderFns } from "./CardPrimaryAction.vue?vue&type=template&id=07746508&"
import script from "./CardPrimaryAction.vue?vue&type=script&lang=js&"
export * from "./CardPrimaryAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports